import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";

const WEBSITE_URL = "https://www.wearetheweave.co.uk";

export default function BeyondAwakePanels() {
  return (
    <div className="grid md:grid-cols-2 gap-4" data-testid="beyond-awake-panels">
      {/* Primary — 1% Club */}
      <Link
        to="/join"
        className="weave-learn-more is-stacked group block relative overflow-hidden"
        style={{
          borderColor: "#4aa0a4",
          background: "linear-gradient(135deg, #4aa0a40d 0%, #f4b8470a 100%)",
        }}
        data-testid="beyond-awake-join-cta"
      >
        <div>
          <p
            className="text-[11px] uppercase tracking-[0.22em] font-medium"
            style={{ color: "#3c8386" }}
          >
            Stay in the room
          </p>
          <h3 className="mt-2 text-2xl md:text-3xl font-light text-slate-800 tracking-tight leading-snug">
            Join The Weave's 1% Club
          </h3>
          <p className="mt-2 text-slate-500 text-sm md:text-base">
            A small membership for founders building something kinder. Monthly
            check-ins, peer rooms, and quiet accountability.
          </p>
        </div>
        <span
          className="weave-btn-primary flex-shrink-0"
          style={{ pointerEvents: "none" }}
          data-testid="beyond-awake-join-btn"
        >
          Explore membership
          <ArrowRight size={16} />
        </span>
      </Link>

      {/* Secondary — Visit The Weave */}
      <a
        href={WEBSITE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="weave-learn-more is-stacked group block"
        data-testid="beyond-awake-website-cta"
      >
        <div>
          <p
            className="text-[11px] uppercase tracking-[0.22em] font-medium"
            style={{ color: "#94a3b8" }}
          >
            Beyond AWAKE
          </p>
          <h3 className="mt-2 text-2xl md:text-3xl font-light text-slate-800 tracking-tight leading-snug">
            Want to learn more about what we do?
          </h3>
          <p className="mt-2 text-slate-500 text-sm md:text-base">
            Step inside The Weave — community, programmes, and the people doing
            the work.
          </p>
        </div>
        <span
          className="weave-btn-outline flex-shrink-0"
          style={{ pointerEvents: "none" }}
          data-testid="beyond-awake-website-btn"
        >
          wearetheweave.co.uk
          <ArrowUpRight size={16} />
        </span>
      </a>
    </div>
  );
}
